(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["med-order-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('usmed-order-guide')) {
    class UsmedOrderGuide extends HTMLElement {
      connectedCallback() {
        if (this.guideConnected) return;
        this.guideConnected = true;
        this.inView = false;
        this.userPaused = false;
        this.startButton = this.querySelector('.med-order-guide-start');
        this.startGuide = () => {
          this.userPaused = false;
          const video = this.createVideo();
          video.focus({ preventScroll: true });
          video.play().catch(() => {});
        };
        if (this.startButton) this.startButton.addEventListener('click', this.startGuide, { once: true });
        this.syncVisibility = () => this.syncPlayback();
        document.addEventListener('visibilitychange', this.syncVisibility);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            const entry = entries[entries.length - 1];
            this.inView = entry.isIntersecting && entry.intersectionRatio >= 0.4;
            this.syncPlayback();
          }, { threshold: [0, 0.4] });
          this.observer.observe(this);
        }
      }
      createVideo() {
        if (this.video) return this.video;
        const video = document.createElement('video');
        video.controls = true;
        video.playsInline = true;
        video.defaultMuted = true;
        video.muted = true;
        video.preload = 'none';
        video.tabIndex = 0;
        video.setAttribute('aria-label', this.dataset.videoTitle);
        if (this.dataset.videoPoster) video.poster = this.dataset.videoPoster;
        this.onVideoPause = () => {
          if (this.inView && !document.hidden && !video.ended) this.userPaused = true;
        };
        this.onVideoPlay = () => { this.userPaused = false; };
        video.addEventListener('pause', this.onVideoPause);
        video.addEventListener('play', this.onVideoPlay);
        video.src = this.dataset.videoUrl;
        this.replaceChildren(video);
        this.video = video;
        return video;
      }
      syncPlayback() {
        if (!this.inView || document.hidden) {
          if (this.video) this.video.pause();
          return;
        }
        if (this.userPaused || (this.video && this.video.ended)) return;
        const video = this.createVideo();
        if (video.paused) video.play().catch(() => {});
      }
      disconnectedCallback() {
        this.guideConnected = false;
        this.inView = false;
        if (this.observer) this.observer.disconnect();
        if (this.startButton && this.startGuide) this.startButton.removeEventListener('click', this.startGuide);
        if (this.syncVisibility) document.removeEventListener('visibilitychange', this.syncVisibility);
        if (this.video) {
          this.video.removeEventListener('pause', this.onVideoPause);
          this.video.removeEventListener('play', this.onVideoPlay);
          this.video.pause();
          this.video.removeAttribute('src');
          this.video.load();
          this.video = null;
        }
      }
    }
    customElements.define('usmed-order-guide', UsmedOrderGuide);
  }

  } catch(e) { console.error(e); }
})();
})();
